angular
	.module 'App.Directive'
	.directive 'tabs', ->
		restrict: 'E'
		scope:
			tabs: '='
			inverted: '<'
		controller: 'TabsController'
		controllerAs: 'tabs'
		bindToController: true
		templateUrl: '@directive/tabs/tabs.view.html'

class TabsController extends BaseController
	@register angular.module 'App.Directive'
	@inject '$interval', '$state', '$transitions', 'MessageTerminal'

	initialize: ->
		@tabsWaitRetries = 0
		@tabsWaitInterval = 50
		@isEventSet = false

		do @initTabs

		@tabsWaiter = @$interval(
			=>
				do @waitForTabs
			,
			@tabsWaitInterval
		)

	##
	# If tabs are located in async directive (e.g. ng-include) then it's possible that it's not present on page yet.
	# We will wait for .5s to load up and then show any tabs that are loaded, others will show warning in console
	#
	# @TODO: Find fix for this issue
	##
	waitForTabs: ->
		missingTabs = []

		for tab in @tabs
			missingTabs.push(tab.selector) if tab.selector? and angular.element(tab.selector).length == 0

		if missingTabs.length == 0 || @tabsWaitInterval * @tabsWaitRetries > 500
			do @setActiveTab
			@$interval.cancel(@tabsWaiter)
			@tabsWaitRetries = 0

			return

		@tabsWaitRetries++
		console.warn 'Waiting for tabs to render #' + @tabsWaitRetries, missingTabs, @tabs

	clearTabErrors: ->
		for tab, index in @tabs
			@removeTabError index

	removeTabError: (tabIndex) ->
		@setTabError(tabIndex, false)

	addTabError: (tabIndex) ->
		@setTabError(tabIndex, true)

	setTabError: (tabIndex, status) ->
		if angular.isUndefined @tabs[tabIndex]
			console.warn 'Unknown tab index', tabIndex
			return

		@tabs[tabIndex].error = status

	changeTab: (tabIndex) ->
		if angular.isUndefined @tabs[tabIndex]
			console.warn 'Unknown tab index', tabIndex
			return

		if @tabs[tabIndex].inactive
			return

		for tab, index in @tabs
			if index == tabIndex
				tab.active = true

				if tab.url?
					@$state.go tab.url.state, if tab.url.params? then tab.url.params else {}

				@MessageTerminal.publish @MessageTerminal.events.TAB_CHANGE, tab, index
			else
				tab.active = false

		do @setActiveTab

	initTabs: ->
		tabIndex = 0
		activeTab = false
		hasUrlTabs = false

		for tab in @tabs
			hasUrlTabs = true if tab.url?
			tabIndex++
			tab.id ?= 'tab-' + tabIndex

			if not tab.url?
				tab.selector ?= '#' + tab.id

				if activeTab == false && tab.active
					activeTab = tab
			else if activeTab == false && @$state.includes(tab.url.state, if tab.url.params then tab.url.params else {})
				activeTab = tab
			else
				tab.active = false

		if activeTab == false
			activeTab = @tabs[0]

		activeTab.active = true

		if hasUrlTabs && @isEventSet == false
			@isEventSet = true
			@$transitions.onSuccess {}, => do @initTabs

	setActiveTab: ->
		for tab in @tabs
			if angular.isDefined tab.selector
				tabContent = angular.element tab.selector

				if tabContent.length == 0
					console.warn('Unknown tab ' + tab.selector)
				else
					tabContent
						.toggleClass 'active', tab.active
						.toggleClass 'inactive ng-hide', !tab.active
